import { render, staticRenderFns } from "./StudyEditor.vue?vue&type=template&id=3ea02aa0&"
import script from "./StudyEditor.vue?vue&type=script&lang=js&"
export * from "./StudyEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ea02aa0')) {
      api.createRecord('3ea02aa0', component.options)
    } else {
      api.reload('3ea02aa0', component.options)
    }
    module.hot.accept("./StudyEditor.vue?vue&type=template&id=3ea02aa0&", function () {
      api.rerender('3ea02aa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/Editor/StudyEditor.vue"
export default component.exports